import { css } from 'styled-components'
import { accents, gray } from 'sutra/tokens/colors'
import { radii } from 'sutra/tokens/radii'
import { typography } from 'sutra/tokens/typography'

export const lineClamp = (lines: number): ReturnType<typeof css> =>
  lines === 1
    ? css`
        max-width: 100%;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        /* overflow only clips a block-level box */
        span&,
        a& {
          display: inline-block;
          vertical-align: bottom;
        }
      `
    : css`
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: ${lines};
        line-clamp: ${lines};
        overflow: hidden;
      `

export const textSizeStyles = {
  xl: css`
    font-size: ${typography.text.xl.fontSize}px;
    line-height: ${typography.text.xl.lineHeight}px;
  `,
  lg: css`
    font-size: ${typography.text.lg.fontSize}px;
    line-height: ${typography.text.lg.lineHeight}px;
  `,
  md: css`
    font-size: ${typography.text.md.fontSize}px;
    line-height: ${typography.text.md.lineHeight}px;
  `,
  sm: css`
    font-size: ${typography.text.sm.fontSize}px;
    line-height: ${typography.text.sm.lineHeight}px;
  `,
  xs: css`
    font-size: ${typography.text.xs.fontSize}px;
    line-height: ${typography.text.xs.lineHeight}px;
  `,
  inherit: css`
    font-size: inherit;
    line-height: inherit;
  `,
} as const

export const textToneStyles = {
  default: css`
    color: ${gray[600]};
  `,
  secondary: css`
    color: ${gray[500]};
  `,
  inherit: css`
    color: inherit;
  `,
  link: css`
    color: ${accents.ceruleanFlow[600]};
    text-decoration: none;
    cursor: pointer;
    &:hover {
      color: ${accents.ceruleanFlow[800]};
      text-decoration: underline;
    }
  `,
} as const

export const codeStyles = css`
  padding: 0.1em 0.4em;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 0.85em;
  background: ${gray[100]};
  border: 1px solid ${gray[200]};
  border-radius: ${radii.xs}px;
`
